import * as CSC from 'SC/App.sc';

export const Container = CSC.BackIconHolder;
